import router from "@/global-config/router/route";


router.beforeEach((to, from, next) => {
    if(to.path.indexOf('app') > -1){
        document.body.classList.remove("blank-page")
    }else{
        document.body.classList.add("blank-page")
    }

    if (to.path == '/' || to.path == '/app/') {
        return next('app');
    } else {
        return next();
    }

})
